import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const location = useLocation();

  useEffect(() => {
    if (inProgress === "none" && accounts.length === 0) {
      instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: location.pathname,
      });
    }
  }, [accounts, inProgress, instance, location.pathname]);

  // While logging in or redirecting, show nothing
  if (inProgress !== "none" || accounts.length === 0) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
